import $ from 'jquery';

var api={
  request(method, url, data) {
    return new Promise((resolve, reject)=>{
      $.ajax({
        url: url,
        data: method=="GET"?$.param(data):JSON.stringify(data),
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        processData: false,
        error: (jqXHR, status, error)=>{
          reject(error);
        },
        type: method,
        success: (data)=>{
          resolve(data);
        },
      });
    });
  },
};

export default api;
